// apps/web/src/components/perfis/comum.ts — quick 261006-lf9.
// Tipos e helpers puros compartilhados pela tela Perfis e permissões.

export interface PerfilResumo {
  readonly id: string;
  readonly nome: string;
  readonly descricao: string;
  readonly sistema: boolean;
  readonly versao: number;
  readonly permissoes: readonly string[];
  readonly usuariosAtivos: number;
  readonly usuariosInativos: number;
}

/** Forma devolvida por GET /api/v1/users (compatível com UserRow). */
export interface PessoaDoPerfil {
  readonly id: string;
  readonly username: string;
  readonly displayName: string;
  readonly email: string | null;
  readonly status: 'ACTIVE' | 'DISABLED';
  readonly role: { readonly id: string; readonly name: string };
  readonly permissions: readonly string[];
}

const ERRO_GENERICO = 'Não foi possível concluir a operação. Nada foi alterado — tente novamente.';
const ERRO_DADOS = 'Confira os dados informados e tente novamente.';

/** Em 400/404/409 mostra a mensagem do servidor (pt-BR); em 5xx ou formato estranho, um texto genérico. */
export function mensagemDoServidor(status: number, corpo: unknown, padrao: string = ERRO_GENERICO): string {
  if (status >= 500) return padrao;
  const mensagem = typeof corpo === 'object' && corpo !== null && 'message' in corpo ? (corpo).message : undefined;
  if (typeof mensagem === 'string' && mensagem.trim().length > 0) return mensagem;
  return status === 400 ? ERRO_DADOS : padrao;
}

/** Corpo do PATCH /users/:id que só troca o perfil, preservando nome e e-mail. */
export function corpoTrocaDePerfil(
  usuario: Pick<PessoaDoPerfil, 'displayName' | 'email'>,
  roleId: string,
): { displayName: string; email: string | null; roleId: string } {
  return { displayName: usuario.displayName, email: usuario.email, roleId };
}

/** Aviso ADR-003: trocar o perfil desconecta a pessoa. */
export function avisoTrocaDePerfil(nomeDaPessoa: string, nomeDoPerfil: string): string {
  return `Ao salvar, ${nomeDaPessoa} será desconectado(a) e precisará entrar de novo para usar o perfil ${nomeDoPerfil}.`;
}
